import { TW_DecimalFilterValueEditor, TW_DecimalFilterValueEditor_editing, TW_DecimalFilterValueEditor_Wrapper } from "@utils/twClasses";
import { useEffect, useState } from "react";
import { displayNumber } from "@utils/types";
import Field from "@dto/fields";
import { AbstractFilterValueEditor } from "./AbstractFilterValueEditor";
import { useModelStore } from "src/store";


type NumberFilterValueEditorProps = {
    pathKey: string | null;
    field: Field | null;
    value: any;
    disabled: boolean;
    onValueChange: (value: any) => void;
}

export function NumberFilterValueEditor({ pathKey, field, value, disabled, onValueChange }: NumberFilterValueEditorProps) {

    const [text, setText] = useState(value || "");
    const [editing, setEditing] = useState(false);
    const selectedView = useModelStore(state => state.selectedView);
    const format = selectedView?.formats?.get(pathKey ?? "") ?? field?.format;
    const intRegex = /^-?\d*$/;

    useEffect(() => {
        setText(value || "");
    }, [value]);


    const textToValue = (text: string | null): any => {
        if (!text || text.length === 0) {
            return null;
        }
        if (text === "-") {
            return 0;
        }
        return parseFloat(text);
    }

    function isTextValid(value: string | null) {
        if (!value || value.length === 0) {
            return true;
        }
        return intRegex.test(value);
    }


    const valueToText = (): string => {
        if (!value || !field) {
            return "";
        }

        return displayNumber(value, format);
    }

    const renderReadOnlyContent = () => {
        return (
            <div className={TW_DecimalFilterValueEditor_Wrapper} onClick={() => setEditing(true)}>
                <div className={TW_DecimalFilterValueEditor}>
                    {valueToText()}
                </div>
            </div>)
    }

    const renderEditingContent = (
        onBlur: () => void,
        onEnterKeyPress: (event: React.KeyboardEvent) => void,
        onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void) => {
        return (<div className={TW_DecimalFilterValueEditor_Wrapper}>
            <input
                className={TW_DecimalFilterValueEditor_editing}
                type="text"
                value={text}
                onBlur={onBlur}
                onKeyDown={onEnterKeyPress}
                onChange={onTextChange}
                disabled={disabled}
                autoFocus />
        </div>)
    }

    return <AbstractFilterValueEditor
        initialValue={value}
        editing={editing}
        renderReadOnlyContent={renderReadOnlyContent}
        renderEditingContent={renderEditingContent}
        textToValue={textToValue}
        isTextValid={isTextValid}
        getText={() => text}
        setText={setText}
        setEditing={setEditing}
        onValueChange={onValueChange} />
}